module.exports = __webpack_public_path__ + "img/kuang.fb494236.png";